import { Button } from "primereact/button";
import { graphql, useFragment, useMutation } from "react-relay";
import { toast } from "react-toastify";
import { useTranslation } from "@i18n/hooks";
import { type RemoveOrderItemProps } from "./remove-order-item-button.interface";
import { type RemoveOrderItemButton_OrderItemFragment$key } from "../../../../__generated__/RemoveOrderItemButton_OrderItemFragment.graphql";
import { type RemoveOrderItemButton_RemoveOrderItemMutation } from "../../../../__generated__/RemoveOrderItemButton_RemoveOrderItemMutation.graphql";
import { useDraftStatusUpdater } from "../use-draft-status-updater";

const ORDER_ITEM_FRAGMENT = graphql`
	fragment RemoveOrderItemButton_OrderItemFragment on OrderItem {
		id
	}
`;

const REMOVE_ORDER_ITEM_MUTATION = graphql`
	mutation RemoveOrderItemButton_RemoveOrderItemMutation($input: RemoveOrderItemInput!) {
		Admin {
			ElearningV2 {
				removeOrderItem(input: $input) {
					orderElement {
						orderItems {
							...OrderItemForm_OrderItemFragment
						}
					}
				}
			}
		}
	}
`;
export const RemoveOrderItemButton = ({
	orderElementId,
	orderItemFragmentRef,
}: RemoveOrderItemProps) => {
	const { t } = useTranslation("common");
	const setDraft = useDraftStatusUpdater();
	const orderItem = useFragment<RemoveOrderItemButton_OrderItemFragment$key>(
		ORDER_ITEM_FRAGMENT,
		orderItemFragmentRef,
	);

	const [removeOrderItem, isRemovingOrderItem] =
		useMutation<RemoveOrderItemButton_RemoveOrderItemMutation>(REMOVE_ORDER_ITEM_MUTATION);

	return (
		<Button
			className="ml-2"
			icon="pi pi-trash"
			type="button"
			disabled={isRemovingOrderItem}
			onClick={() =>
				removeOrderItem({
					variables: {
						input: {
							orderElementId,
							orderItemId: orderItem.id,
						},
					},
					onCompleted: () => {
						toast.success(t("messages.orderItemRemoved"));
					},
					onError: () => {
						toast.error(t("messages.orderItemRemoveError"));
					},
					updater: setDraft,
				})
			}
		/>
	);
};
